import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Header from './Header';
import Sidebar from './Sidebar';
import MainContentStyled from './MainContentStyled';
import Loader from '../../components/Loader';
import Breadcrumbs from '../../components/extended/Breadcrumbs';

import useConfig from '../../hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from '../../api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

export default function MainLayout1() {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));

  const { borderRadius, miniDrawer } = useConfig();
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  useEffect(() => {
    handlerDrawerOpen(!miniDrawer);
  }, [miniDrawer]);

  useEffect(() => {
    downMD && handlerDrawerOpen(false);
  }, [downMD]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* header */}
      <AppBar
        enableColorOnDark
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: 'background.default',
          top: 0,
          width: '100%',
          zIndex: 1200,
          overflow: 'visible',
        }}
      >
        <Toolbar sx={{ p: 2, position: 'relative' }}>
          <Header />
        </Toolbar>
      </AppBar>

      <Box sx={{ display: 'flex', flex: 1, pt: '64px', mt: 2 }}>
        {/* menu / drawer */}
        <Sidebar sx={{ mt: 2 }} />

        {/* main content */}
        <MainContentStyled {...{ borderRadius, open: drawerOpen }}>
          <Box sx={{ minHeight: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
            {/* breadcrumb */}
            <Breadcrumbs />
            <Outlet />
          </Box>
        </MainContentStyled>
      </Box>
    </Box>
  );
}